var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-filter-textsearch"},[_c('string-filter-component',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder},on:{"changed":_vm.onChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }